<template>
	<FeatureDescriptionPreviewTemplate iconName="feature-description-preview">
		<template #description>Appears next to the add-on when it’s visible to the user for the first time</template>
		<template #left-bottom>
			<Col>
				<template v-if="!isLoading">
					<Row class="flex-align-center flex-justify-space-between">
						<h5 class="switch-text">Show overlay</h5>
						<AppSwitch class="swtch sml" v-model="showOverlay" />
					</Row>
					<Row class="flex-align-center flex-justify-space-between mt-2">
						<h5 class="switch-text">Creator avatar on overlay</h5>
						<AppSwitch class="swtch sml" v-model="showCreatorAvatarOverlay" />
					</Row>
				</template>
				<AppLoader v-else />
			</Col>
		</template>
		<template #floating-card>
			<Col v-if="showOverlay" class="preview-card">
				<AppAvatar v-if="showCreatorAvatarOverlay" :size="23" />
				<div class="preview-text mt-1 three-row">{{ onboardingText }}</div>
			</Col>
		</template>
	</FeatureDescriptionPreviewTemplate>
</template>
<script>
import { mapActionsShorthand } from '@/store/utils/mappers';
import { updateWorkflow } from '@/store/modules/workflows/actions';
import FeatureDescriptionPreviewTemplate from '@/components/dialogs/OnboardingTextEditorDialog/FeatureDescriptionPreview/FeatureDescriptionPreviewTemplate.vue';
export default {
	name: 'FeatureDescriptionOnboardingOverlay',
	components: { FeatureDescriptionPreviewTemplate },
	props: {
		workflow: { type: Object },
		onboardingText: { type: String },
	},
	computed: {
		onboardingSettings() {
			return this.workflow?.onboarding_settings || {};
		},
		showOverlay: {
			// These fields are not in the workflow object until they are set. so, I am using the negative form on purpose
			get() {
				return !this.onboardingSettings.hide_overlay;
			},
			set(value) {
				this.updateOverlaySettings('hide_overlay', !value);
			},
		},
		showCreatorAvatarOverlay: {
			// These fields are not in the workflow object until they are set. so, I am using the negative form on purpose
			get() {
				return !this.onboardingSettings.hide_creator_avatar;
			},
			set(value) {
				this.updateOverlaySettings('hide_creator_avatar', !value);
			},
		},
	},
	methods: {
		...mapActionsShorthand({ updateWorkflow }),
		async updateOverlaySettings(key, value) {
			const currentSettings = this.onboardingSettings;
			currentSettings[key] = value;
			try {
				this.isLoading = true;
				await this.updateWorkflow({ id: this.workflow.id, data: { onboarding_settings: currentSettings } });
			} catch (e) {
				this.$toast.error('Failed to update, please try again later');
			} finally {
				this.isLoading = false;
			}
		},
	},
	data() {
		return { isLoading: false };
	},
};
</script>
<style scoped lang="scss">
.preview-card {
	left: 45px;
	bottom: 90px;
	width: 238px;
	height: 83px;
	padding: 10px;
	position: absolute;
	border-radius: 12px;
	background: #ffffff;
	border: 1px solid #e0e5ef;
	box-shadow: 0px 3px 6px #00000029;
}
.preview-text {
	font-size: 10px;
	line-height: 11px;
	letter-spacing: 0px;
	font-weight: normal;
	color: var(--primary-font-color);
}
.three-row {
	overflow: hidden;
	display: -webkit-box;
	text-overflow: ellipsis;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 3; // num of rows to break
}
.switch-text {
	color: #303133;
}
</style>
